import jQuery from 'jquery'
import axios from 'axios'
import state from '@/store'
import { userAuthenticat } from '@/api'
import { mapActions, mapGetters, mapState } from 'vuex'
import { SUBMIT_ANALYST_CONTACT } from '@/store/actions.type'
import { PANARAY_SERVICES_URL } from '@/api/config'

export default {
  name: 'analystAskModal',
  data() {
    return {
      email: '',
      password: '',
      userEmail: this.$store.state.auth.user.email,
      userName: this.$store.state.auth.user.username,
      contactdel: 'email',
      yourmessage: '',
      userPhone: '',
      username: '',
      errormessage: '',
      errorusername: '',
      erroruseremailpassword: '',
      reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
      errorlogin: '',
      errorpassowrd: '',
      analystname: '',
      analystPhone: '',
      loginhelp: this.$store.state.appsetting.loginhelp ? this.$store.state.appsetting.loginhelp : ''
    }
  },

  created: function () {
    this.showPanarylogin()
  },
  computed: {
    ...mapState( {
      isLogin: ( state ) => !state.auth.isAuthenticated
    } ),
    loginhelpLoading() {
      this.loginhelp = this.$store.state.appsetting.loginhelp ? this.$store.state.appsetting.loginhelp : ''
      return this.$store.state.appsetting.loginhelpLoading
    }
  },
  methods: {
    ...mapActions( {
      submitanalystcontact: SUBMIT_ANALYST_CONTACT
    } ),
    showPanaryhelp: function ( event ) {
      event.preventDefault()
      jQuery( '.loginform' ).hide()
      jQuery( '.panarayHelp' ).show()
    },
    hideModal() {
      this.$refs.modal.hide()
    },
    showPanarylogin: function () {
      // event.preventDefault();
      jQuery( '.loginform' ).show()
      jQuery( '.panarayError' ).hide()
      jQuery( '.panarayHelp' ).hide()
    },
    showErrors: function () {
      // event.preventDefault();
      jQuery( '.loginform' ).hide()
      jQuery( '.panarayError' ).show()
    },
    ...mapGetters( ['analystdetials'] ),
    setanalystinfo() {
      var analystdetials = this.analystdetials()
      this.analystname = analystdetials.analystname
      this.seletedAnalyst = analystdetials.analystname
      this.seletedAvatar = analystdetials.avatar
      this.analystcoverage = analystdetials.analystcoverage
      this.analystdescription = analystdetials.analystdescription
      this.analystPhone = analystdetials.analystphone
      return this.analystdetials().analystemail
    },
    programEncryptEmail: function ( email ) {
      var Min = 1
      var Max = 4
      var Const = 64

      if ( email === null ) {
        return null
      }
      var iLength = email.length
      var cLast = []
      cLast.length = iLength + 1

      var rdm = Math.floor( Math.random() * ( Max - Min + 1 ) ) + Min
      for ( var iPosn = 0; iPosn < iLength; iPosn++ ) {
        cLast[iPosn] = ( email.charCodeAt( iPosn ) + rdm ) & 0xffff
      }
      cLast[iLength] = ( rdm + Const ) & 0xffff
      var str = ''
      for ( var i in cLast ) {
        str += String.fromCharCode( cLast[i] )
      }
      return str
    },

    getUserdata: function ( email ) {
      var encEmail = this.programEncryptEmail( email )
      userAuthenticat.login( encEmail, 'userData' )
    },
    clearName() {
      this.email = ''
      this.password = ''
    },
    handleOk( evt ) {
      // Prevent modal from closing
      evt.preventDefault()
      if ( !this.email ) {
        this.errorlogin = 'Please enter your Email'
      } else if ( !this.reg.test( this.email ) ) {
        this.errorlogin = 'Please enter your valid Email'
      } else if ( !this.password ) {
        this.errorpassowrd = 'Please enter your Password'
      } else {
        this.errorlogin = ''
        this.errorpassowrd = ''
        this.handleSubmitevt()
      }
    },
    async handleSubmitevt() {
      this.loading = true
      axios.defaults.headers.common['Authorization'] = 'Basic ' + btoa( this.email + ':' + this.password )
      axios
        .post( PANARAY_SERVICES_URL )
        .then( ( response ) => {
          // console.log(response)
          if ( response.status === 200 ) {
            _satellite.track( 'loginSuccess' )
            this.getUserdata( this.email )
            this.$refs.modal.hide()
          }
        } )
        .catch( ( error ) => {
          _satellite.track( 'loginError' )
          // console.log( error )
          this.showErrors()
        } )
      // this.names.push(this.name)
      // this.clearName()
    },
    submitLoginAnalystBtn( evt ) {
      evt.preventDefault()
      if ( !this.yourmessage ) {
        this.errormessage = 'Please enter your yourmessage'
      } else if ( !this.userName ) {
        this.errorusername = 'Please enter your username'
      } else if ( !this.userEmail && !this.userPhone ) {
        this.erroruseremailpassword = 'Please enter your Email or Phone'
      } else if ( !this.reg.test( this.userEmail ) ) {
        this.erroruseremailpassword = 'Please enter your valid Email'
      } else {
        this.errormessage = ''
        this.errorusername = ''
        this.erroruseremailpassword = ''
        var formfields = {}
        formfields['your-name'] = this.userName
        formfields['radio-867'] = this.contactdel
        formfields['your-message'] = this.yourmessage
        formfields['your-email'] = this.userEmail
        formfields['recipient-email'] = this.analystdetials().analystemail
        this.submitanalystcontact( formfields )
        this.$refs.modal.hide()
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/analystAskModal.js